<mat-select-country
  class="country-code-select"
  [countries]="countries"
  [appearance]="appearance"
  label=" "
  [value]="defaultCountry"
  [showCallingCode]="false"
  (onCountrySelected)="selected($event)"
>
  <input matInput formControlName="country" required />
</mat-select-country>
